import { discountTypes } from "@ac-expo/api-types";
import { DiscountType } from "@prisma/client";
import { z } from "zod";
import { defaultCreateDiscountValues } from "./create-discount.schema";

export const createDegressivePriceSchema = z
  .object({
    id: z.string().optional(),
    minQuantity: z.coerce
      .number()
      .int()
      .gte(0, "La quantité minimale doit être positive")
      .nullish(),
    maxQuantity: z.coerce
      .number()
      .int()
      .gte(0, "La quantité maximale doît être positive")
      .nullish(),

    discount: z
      .object({
        id: z.string().optional(),
        type: z.enum(discountTypes as [DiscountType, ...DiscountType[]]),
        value: z.coerce
          .number({ invalid_type_error: "La réduction est requise" })
          .gt(0, "Le réduction doit être supérieur à 0"),
      })
      .refine(({ type, value }) => type !== "percentage" || value <= 100, {
        message: "La réduction ne peut pas être supérieure à 100%",
        path: ["value"],
      }),
  })
  .refine(({ minQuantity, maxQuantity }) => minQuantity || maxQuantity, {
    message: "Au moins une quantité doit être renseignée",
  })
  .refine(
    ({ minQuantity, maxQuantity }) =>
      !minQuantity || !maxQuantity || minQuantity <= maxQuantity,
    {
      message:
        "La quantité minimale doit être inférieure à la quantité maximale",
      path: ["minQuantity"],
    }
  );

export const defaultCreateDegressivePriceValues = {
  minQuantity: null,
  maxQuantity: null,
  discount: defaultCreateDiscountValues,
};

export type CreateDegressivePrice = z.infer<typeof createDegressivePriceSchema>;
